import { render } from "./PurchaseReportContent.vue?vue&type=template&id=15b02a22"
import script from "./PurchaseReportContent.vue?vue&type=script&lang=js"
export * from "./PurchaseReportContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__